import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import "./map-deals.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApiCallServices from "../../../../services/ApiCallServices";
import { END_POINTS } from '../../../../services/endpoint/endPoint';
import MapDealsList from "./child/MapDealsList";
import button from "../../../button.module.css";
import MapDealMultiselectCheckbox from './child/MapDealMultiselectCheckbox';

const MapDeals = () => {
    const [tableData, setTableData] = useState([]);
    const [search, setSearch] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState([]);
    const [partnerList, setPartnerList] = useState([]);
    const [clentList, setClientList] = useState([]);
    const [selectedFilterClient, setSelectedFilterClient] = useState([]);
    const [selectedFormClient, setSelectedFormClient] = useState([]);
    const [dealCodeList, setDealCodeList] = useState([]);
    const [selectedFormDealCode, setSelectedFormDealCode] = useState();
    const [dealMargin, setDealMargin] = useState();
    const [errors, setErrors] = useState({});
    const [sortingColumn, setSortingColumn] = useState(null);
    const [sortingOrder, setSortingOrder] = useState('asc');
    const [showHideModal, setShowHideModal] = useState(false)
    const [loader, setLoader] = useState(false);
    const [marginChange, setMarginChange] = useState()

    const [demandList, setDemandList] = useState([])
    const [ selectedDemand, setSelectedDemand] = useState()
    // const [newDeal, setNewDeal] = useState(initialDeal);

    const [selectedNewDemand, setSelectedNewDemand] = useState()

    const getDealsTableData = () => {
        setLoader(true)
        const data = { 
            name: search, 
            client_id: selectedFilterClient?.id ,
            sortingcolumn: sortingColumn, 
            sortingorder: sortingOrder,
            demand_id: selectedDemand?.id || ''
        };
        ApiCallServices.create(END_POINTS.mapdealListing, data).then((res) => {
            const data = res.data.data;
            if (res.status === 200) {
                setTableData(data);
                setLoader(false)
            }
        })
        .catch((error) => {
            if (error.response) {
                console.log("error in getting response ====>", error.response.data.error)
                toast.error(error.response.data.error, {
                    position: "top-right"
                });
            } 
        });
    };

    useEffect(() => {
        getDealsTableData();
    }, [search, selectedFilterClient, sortingColumn, sortingOrder, marginChange, selectedDemand]);

    const deleteMapDeal = (id) => {
        ApiCallServices.create(END_POINTS.deleteMapDeal, { id: id }).then((res) => {          
            if (res.status === 200) {
                toast.success(res.data.message, {
                    position: "top-right"
                });
                getDealsTableData();
            }
        })
        .catch((error) => {
            if (error.response) {
                toast.error(error.response.data.error, {
                    position: "top-right"
                });
            } 
        });           
    };

    const confirmDelete = (id) => {
        if (window.confirm('Are you sure you want to delete map deal')) {
            deleteMapDeal(id);
        }
    }

    const updateDealStatus = (id, status) => {
        ApiCallServices.create(END_POINTS.updateMapDealStatus, { id: id, status: status }).then((res) => {
            if (res.status === 200) {
                toast.success(res.data.message, {
                    position: "top-right"
                });
                getDealsTableData();
            }
        })
        .catch((error) => {
            if (error.response) {
                toast.error(error.response.data.error, {
                    position: "top-right"
                });
            } 
        });
    };

    const confirmUpdate = (id, status) => {
        if (window.confirm('Are you sure you want to Update the status')) {
            updateDealStatus(id, status);
        }
    }

    const searchDeal = (e) => {
        if (e.target.value.length > 1) {
            setSearch(e.target.value);
        } else {
            setSearch('');
        }
    };

    const handleSort = (column) => {
        if (sortingColumn === column) {
            setSortingOrder(sortingOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortingColumn(column);
            setSortingOrder('asc');
        }
    };

    const getPartnerList = () => {
        ApiCallServices.getlisting(END_POINTS.partnerList).then((res) => {
            if (res.status === 200) {
                setPartnerList(res.data.data);
            }
        })
        .catch((error) => {
            if (error.response) {
                toast.error(error.response.data.error, {
                    position: "top-right"
                });
            }
        });
    };

    useEffect(() => {
        getPartnerList();
    }, []);

    const getClientList = () => {
        ApiCallServices.getlisting(END_POINTS.clientList).then((res) => {
            if (res.status === 200) {
                setClientList(res.data.data);
            }
        })
        .catch((error) => {
            if (error.response) {
                toast.error(error.response.data.error, {
                    position: "top-right"
                });
            }
        });
    };

    useEffect(() => {
        getClientList();
    }, []);

    const handleClientChange = (values) => {
        setSelectedFilterClient(values);
    };

    const handlePatrenFormChange = (selectedValue) => {
        setSelectedPartner(selectedValue);
    };

    const handleFormClientChange = (values) => {
        setSelectedFormClient(values);
    };

    const getDealCodeList = () => {
        let data = {
            supply_partner_id: (selectedPartner?.id) ? selectedPartner?.id : '',
            client_id: selectedFormClient?.id ? selectedFormClient?.id : '',
        }
        if (selectedPartner?.id && selectedFormClient?.id) { 
            ApiCallServices.create(END_POINTS.dealCodeList, data).then((res) => {
                if (res.status === 200) {
                    setDealCodeList(res.data.data);
                }
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.error, {
                        position: "top-right"
                    });
                    console.log(error.response, "===>error in getting response");
                }
            });
        }
    };

    
    useEffect(() => {
        getDealCodeList();
    }, [selectedPartner?.id, selectedFormClient?.id ]);


    const handleFormDealCode = (value) => {
        setSelectedFormDealCode(value);
    };

    const handleMarginchange = (e) => {
        setDealMargin(e.target.value)
    }

    const validateForm = () => {
        const errors = {};
        if (!selectedPartner || selectedPartner.length === 0) errors.selectedPartner = "Supply Partner is required";
        if (!selectedFormClient || selectedFormClient.length === 0) errors.selectedFormClient = "Client is required";
        if (!selectedFormDealCode || selectedFormDealCode.length === 0) errors.selectedFormDealCode = "At least one Deal Name is required";
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }

        let dealids = selectedFormDealCode?.map((item) => item.id);
        let obj = {
            supply_partner: selectedPartner?.id,
            deal_id: dealids,
            client_id: selectedFormClient?.id,
            deal_margin: Number(dealMargin)
        };

        ApiCallServices.create(END_POINTS.createMapDeal, obj).then((res) => {
            if (res.status === 200) {
                getDealsTableData();
                toast.success(res.data.message, {
                    position: "top-right"
                });
                setSelectedFormDealCode(null);
                setSelectedPartner(null);
                setSelectedFormClient(null);
                document?.body?.removeAttribute('style');
                setShowHideModal(false)
            }
        })
        .catch((error) => {
            if (error.response) {
                toast.error(error.response.data.error, {
                    position: "top-right"
                });
                console.log(error.response, "===>error in getting response");
            }
        });
    };

    const handleFormReset = () => {
        setSelectedFormDealCode(null);
        setSelectedPartner(null);
        setSelectedFormClient(null);
        setShowHideModal(false)
        setErrors({});
    };

    const handleHideShowModal = () => {
        setShowHideModal(true)
        document.body.style = 'overflow: hidden'
    }

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#fff' : state.isFocused ? '#6abfe94d' : undefined,
            color: state.isSelected ? 'white' : 'black',
            padding: 10,
            display: 'flex',
            alignItems: 'center',
        }),
    };

    // const updateMargin = (newMargin, msg) => {
    //     setMarginChange(newMargin);
    //     if (newMargin) {
    //         toast.success(msg, {
    //             position: "top-right"
    //         });
    //     }
    // };

    const validateMargin = (margin) => {
        if (margin === "") {
            toast.error("Deal margin cannot be empty", {
                position: "top-right"
            });
            return false;
        }
        const marginNumber = Number(margin);
        if (isNaN(marginNumber) || marginNumber < 0 || marginNumber > 99.99) {
            toast.error("Deal margin must be a number between 0.00 and 99.99", {
                position: "top-right"
            });
            return false;
        }
        return true;
    };

    const handleUpdateDealMargin = (id, margin) => {
        if (!validateMargin(margin)) {
            return;
        }
        updateDealMargin(id, margin);
    };

    const updateDealMargin = (id, margin) => {
        
        if(window.confirm("do you want to update")){
            setMarginChange(margin);
            const data = { id: id, deal_margin: margin };
            ApiCallServices.create(END_POINTS.updateDealMargin, data).then((res) => {
                if(res.data.status == "success"){
                    toast.success(res.data.message, {
                        position: "top-right"
                    });
                }
            })
        
        .catch((error) => {
            if (error.response) {
                console.log("Error in getting response ====>", error.response.data.error);
            }
        });
      }
    };

    const getDemandPartnerList = () => {
        ApiCallServices.getlisting(END_POINTS.demandPartnerList).then((res) => {
            if(res.status == 200){
                setDemandList(res.data.data)
            }
        })
        .catch((error) => {
            // Handle errors here
            if (error.response) {
                toast.error(error.response.data.error, {
                    position: "top-right"
                });
                console.log(error.response, "===>error in getting response");
            } 
        });

      }
      
      useEffect(() => {
        getDemandPartnerList()
      }, [])

      const demandFilterChange = (value) => {
        setSelectedDemand(value)
      }

      const handleNewDemandChange = (value) => {
        setSelectedNewDemand(value)
      }

      const mapDemandPartner = (val, dealId) => {
        const data = {
            demand_partner_id: val?.id,
            deal_id: dealId,
        };
        ApiCallServices.create(END_POINTS.mapDealDemandFromTable, data).then((res) => {
            if (res.status === 200) {
                getDealsTableData();
                toast.success(res.data.message, {
                    position: "top-right"
                });
            }
        })
        .catch((error) => {
            if (error.response) {
                toast.error(error.response.data.error, {
                    position: "top-right"
                });
                console.log(error.response, "===>error in getting response");
            }
        });
      }

    return (
        <>
            <ToastContainer />
            <div className="container-fluid">
            <div className='filter-wraper justify-content-between'>
                <div className='d-flex align-items-center fields'>
                    <h3>Map Deals</h3>
                </div>
            </div>
            
                <div className='filter-wraper justify-content-between'>
                    <div className='d-flex align-items-center fields'>
                        <div className='form-group search-icon'>
                            <input type='text' className='form-control' onChange={searchDeal} placeholder='Search by client name, partner & deal'/>
                        </div>
                        <div className="form-group custome-select">
                            <Select
                                placeholder="Select Client"
                                value={selectedFilterClient}
                                isClearable= "true"
                                onChange={handleClientChange}
                                options={clentList}
                                getOptionLabel={(clentList) => clentList.name}
                                getOptionValue={(clentList) => clentList.id}
                            />
                        </div>
                        <div className="form-group custome-select">
                            <Select
                                placeholder="Select Demand Partner"
                                isClearable= "false"
                                value={selectedDemand}
                                onChange={demandFilterChange}
                                options={demandList}
                                getOptionLabel={(demandList) => demandList.name}
                                getOptionValue={(demandList) => demandList.id}
                            />
                        </div>
                    </div>
                    <div className='form-group d-flex justify-content-end'>
                        <button type="button" className={`${button.btn} ${button.btnDarkBlue}`} onClick={handleHideShowModal}>Map Deal With Client</button>
                    </div>
                </div>
                <MapDealsList 
                    tableData={tableData} 
                    updateDealMargin={handleUpdateDealMargin} 
                    updateDealStatus={updateDealStatus} 
                    onSort={handleSort} 
                    delDeal={confirmDelete}  
                    updateStatus={confirmUpdate} 
                    loader={loader} 
                    mapDemandPartner={mapDemandPartner}
                    demandList={demandList}
                />
            </div>

            <div className={`modal form-modal ${showHideModal ? 'show' : ''}`}>
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Map Deal With Client</h4>
                            <i className="fa-regular fa-circle-xmark close-icon" data-bs-dismiss="modal" onClick={handleFormReset}></i>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleFormSubmit}>
                                <div className="form-wraper">
                                    <div className="form-group custome-select">
                                        <label>Supply Partner <span className="astric">*</span></label>
                                        <Select
                                            placeholder="Select Supply Partner"
                                            isSearchable={false}
                                            value={selectedPartner}
                                            onChange={handlePatrenFormChange}
                                            options={partnerList}
                                            getOptionLabel={(partnerList) => partnerList.name}
                                            getOptionValue={(partnerList) => partnerList.id}
                                        />
                                        {errors.selectedPartner && <div className="input-error">{errors.selectedPartner}</div>}
                                    </div>
                                    <div className="form-group custome-select">
                                        <label>Demand Partner</label>
                                        <Select
                                            placeholder="Select Demand Partner"
                                            value={selectedNewDemand}
                                            onChange={handleNewDemandChange}
                                            options={demandList}
                                            defaultValue={demandList}
                                            getOptionLabel={(demandList) => demandList.name}
                                            getOptionValue={(demandList) => demandList.id}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Client <span className="astric">*</span></label>
                                        <Select
                                            placeholder="Select Client"
                                            value={selectedFormClient}
                                            isSearchable={false}
                                            onChange={handleFormClientChange}
                                            options={clentList}
                                            getOptionLabel={(clentList) => clentList.name}
                                            getOptionValue={(clentList) => clentList.id}
                                        />
                                        {errors.selectedFormClient && <div className="input-error">{errors.selectedFormClient}</div>}
                                    </div>
                                    <div className="form-group custome-select multicheck">
                                        <label>Deal Name <span className="astric">*</span></label>
                                        <Select
                                            placeholder="Select Deal Name"
                                            value={selectedFormDealCode}
                                            isMulti={true}
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={false}
                                            onChange={handleFormDealCode}
                                            options={dealCodeList}
                                            getOptionLabel={(dealCodeList) => dealCodeList.deal_name}
                                            getOptionValue={(dealCodeList) => dealCodeList.id}
                                            components={{ 
                                                Option: (props) => (
                                                  <MapDealMultiselectCheckbox
                                                    {...props}
                                                  />
                                                )
                                              }}
                                              styles={customStyles}
                                        />
                                        {errors.selectedFormDealCode && <div className="input-error">{errors.selectedFormDealCode}</div>}
                                    </div>
                                    <div className="form-group">
                                        <label>Deal Margin </label>
                                        <input type="text" placeholder="Enter Deal Margin 0.00 To 99.99" onChange={handleMarginchange} value={dealMargin} name= "deal_margin" className='form-control'  />
                                        {errors.deal_margin && <div className='input-error'>{errors.deal_margin}</div>}
                                    </div>
                                    <div className='text-end'>
                                        <button type="submit" className={`${button.btn} ${button.btnBlue}`}>Save</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${showHideModal ? 'overlay' : ''}`}></div>
        </>
    );
}

export default MapDeals;
